import PropTypes from 'prop-types';

import YoutubeVideo from '@spotahome/marketplace-common/src/components/YoutubeVideo';

import './SliderTrackVideo.scss';

const SliderTrackVideo = ({ item }) => (
  <div className="slider-video">
    <YoutubeVideo {...item} />
  </div>
);

SliderTrackVideo.propTypes = {
  item: PropTypes.shape(YoutubeVideo.propTypes).isRequired
};

export default SliderTrackVideo;
